<nav class="navbar navbar-expand-xl navbar-dark bg-dark">
  <div id="start" class="container-fluid">

    <div class="left">
      <a class="navbar-brand" routerLink='/home'>Profil von Gerd Gruber</a>
    </div>

    <div class="navbar-light navbar-nav profilfloatright">
      <span class="navbar-brand" *ngIf="isAuthenticated"><i class="bi bi-person-fill"></i>{{ username }}</span>
      <span *ngIf="isAuthenticated" (click)="logout()"><a class="navbar-brand link nav-link cursor-pointer">logout</a></span>
      <div class="profilfloatleft"><a class="link nav-link {{ locale_it }}" href="/it/">IT</a></div>
      <div class="profilfloatleft"><a class="link nav-link {{ locale_fr }}" href="/fr/">FR</a></div>
      <div class="profilfloatleft"><a class="link nav-link {{ locale_de }}" href="/de/">DE</a></div>
      <div class="profilfloatleft"><a class="link nav-link {{ locale_en }}" href="/en/">EN</a></div>
    </div>

  </div>
</nav>

<nav class="navbar navbar-expand-xl navbar-light bg-light profil">
  <div class="container">

    <button class="navbar-toggler border-0" type="button" (click)="isCollapsed = !isCollapsed" data-toggle="collapse" data-target="#header-menu" aria-controls="header-menu" aria-expanded="false" aria-label="Anzeigen/Navigation ausblenden">
      <span class="navbar-toggler-icon"></span>
    </button>

<!--    <div [ngbCollapse]="isCollapsed" class="collapse navbar-collapse" id="header-menu">-->
    <div class="collapse navbar-collapse" id="header-menu">
      <ul class="nav navbar-nav ml-auto">
        <li routerLinkActive="active" class="nav-item ml-4 profilleft" (click)="isCollapsed = true"><a routerLinkActive="active" class="link nav-link" routerLink="/home">home</a></li>
        <li routerLinkActive="active" class="nav-item ml-4 profilleft" (click)="isCollapsed = true"><a routerLinkActive="active" class="link nav-link" routerLink="/membership">MemberShip</a></li>
        <li routerLinkActive="active" class="nav-item ml-4 profilleft" (click)="isCollapsed = true"><a routerLinkActive="active" class="link nav-link" routerLink="/saas">SasS <span class="smaller">S<span class="notbold">oftware_</span>a<span class="notbold">s_</span>a<span class="notbold">_</span>S<span class="notbold">ervice</span></span></a></li>
        <li routerLinkActive="active" class="nav-item ml-4 profilleft" (click)="isCollapsed = true"><a routerLinkActive="active" class="link nav-link" routerLink="/info">info</a></li>
        <li routerLinkActive="active" class="nav-item ml-4 profilleft" (click)="isCollapsed = true"><a routerLinkActive="active" class="link nav-link" routerLink="/shop">shop</a></li>
        <li routerLinkActive="active" class="nav-item ml-4 profilleft" (click)="isCollapsed = true"><a routerLinkActive="active" class="link nav-link" routerLink="/registrieren">registrieren</a></li>
        <li routerLinkActive="active" class="nav-item ml-4 profilleft" (click)="isCollapsed = true"><a routerLinkActive="active" class="link nav-link" routerLink="/myeasyfind"><i class="bi bi-person-fill"></i> my easyfind</a></li>
        <li routerLinkActive="active" class="nav-item ml-4 profilleft  profilright" (click)="isCollapsed = true"><a routerLinkActive="active" class="nav-link" routerLink="/businesskunden">businesskunden</a></li>
      </ul>
    </div>

  </div>
</nav>
